import React, { useState, useEffect, memo } from "react";
import { SplineSurface, Spline, MakeSplinePoints } from "../shape/Spline";
import { PointsClick } from "../shape/PointClick";
import { Vpoints2Points } from "../shape/Adapter";
import { DIV_LINE } from '../store/global';

//-----------------------------------------
// 与えられた点群vpoints（＝クリック可能）と、
// それらの点をsplineで結んだ線or平面を描画するマーカである。
// showtypeは点群を結ぶ部分の表示を線(1D)か平面(2D)で指定する。
// クリックした点は削除される。
//-----------------------------------------

// mode: 0:ADD  1:DELETE
const MPoints2DDel = memo(({ vpoints, colorLine, colorClick, size, showtype, callback }) => {
  var [lvpoints, setVpoints] = useState(vpoints);

  const callDel = (uuid) => {
    console.log("-----callDel-----", uuid);
    if(lvpoints.length < 5) {
      console.log("Can't delete node because only 4 lefts.");
      return;
    }
    var newnodes = lvpoints.slice();
    newnodes.splice(uuid, 1);
    setVpoints(newnodes);  
  }

  useEffect(() => {
    //Save Points
    const sp = MakeSplinePoints(lvpoints, false, DIV_LINE);
    const sparr = Vpoints2Points(sp);
    callback(sparr);
  }, [lvpoints]);

  return (
    <>
      {(showtype == "2D")
        ? <SplineSurface vpoints={lvpoints} width={200} color={colorLine} close={false} div={5}/>
        : <Spline vpoints={lvpoints} color={colorLine} close={false} lineWidth={1} div={5}/>}
      <PointsClick vpoints={lvpoints} color={colorClick} size={size} callback={callDel}/>
    </>
  );
});
export default MPoints2DDel;
